import {
  CompanyMobileActionButton,
  CompanyMobileAlert,
  CompanyMobileDataTable,
  CompanyMobileDetailLabel,
  CompanyMobileDetailRow,
  CompanyMobileDetailRows,
  CompanyMobileDetailSection,
  CompanyMobileDetailSectionHeader,
  CompanyMobileDetailValue,
  CompanyMobileField,
  CompanyMobileFilterActions,
  CompanyMobileFilterApplyButton,
  CompanyMobileFilterButton,
  CompanyMobileFilterDrawer,
  CompanyMobileFilterField,
  CompanyMobileFilterFields,
  CompanyMobileFilterForm,
  CompanyMobileFilterRow,
  CompanyMobileFilterSelect,
  CompanyMobileForm,
  CompanyMobileHeaderActions,
  CompanyMobileIconButton,
  CompanyMobileImagePreview,
  CompanyMobileImageSection,
  CompanyMobileNoImagePreview,
  CompanyMobilePage,
  CompanyMobilePageButton,
  CompanyMobilePagination,
  CompanyMobilePaginationActions,
  CompanyMobilePaginationInfo,
  CompanyMobileSearch,
  CompanyMobileSecondaryButton,
  CompanyMobileSection,
  CompanyMobileSectionHeader,
  CompanyMobileSwitchField,
  CompanyMobileSwitchGrid,
  CompanyMobileUploadPanel,
  MobileCompanyHeader,
} from '../company/mobile';
import styled from 'styled-components';

export const AssetMobilePage = CompanyMobilePage;
export const AssetMobileActionButton = CompanyMobileActionButton;
export const AssetMobileAlert = CompanyMobileAlert;
export const AssetMobileDataTable = CompanyMobileDataTable;
export const AssetMobileDetailLabel = CompanyMobileDetailLabel;
export const AssetMobileDetailRow = CompanyMobileDetailRow;
export const AssetMobileDetailRows = CompanyMobileDetailRows;
export const AssetMobileDetailSection = CompanyMobileDetailSection;
export const AssetMobileDetailSectionHeader = CompanyMobileDetailSectionHeader;
export const AssetMobileDetailValue = CompanyMobileDetailValue;
export const AssetMobileField = CompanyMobileField;
export const AssetMobileFilterActions = CompanyMobileFilterActions;
export const AssetMobileFilterApplyButton = CompanyMobileFilterApplyButton;
export const AssetMobileFilterButton = CompanyMobileFilterButton;
export const AssetMobileFilterDrawer = CompanyMobileFilterDrawer;
export const AssetMobileFilterField = CompanyMobileFilterField;
export const AssetMobileFilterFields = CompanyMobileFilterFields;
export const AssetMobileFilterForm = CompanyMobileFilterForm;
export const AssetMobileFilterRow = CompanyMobileFilterRow;
export const AssetMobileFilterSelect = CompanyMobileFilterSelect;
export const AssetMobileForm = CompanyMobileForm;
export const AssetMobileHeaderActions = CompanyMobileHeaderActions;
export const AssetMobileIconButton = CompanyMobileIconButton;
export const AssetMobileImagePreview = CompanyMobileImagePreview;
export const AssetMobileImageSection = CompanyMobileImageSection;
export const AssetMobileNoImagePreview = CompanyMobileNoImagePreview;
export const AssetMobilePageButton = CompanyMobilePageButton;
export const AssetMobilePagination = CompanyMobilePagination;
export const AssetMobilePaginationActions = CompanyMobilePaginationActions;
export const AssetMobilePaginationInfo = CompanyMobilePaginationInfo;
export const AssetMobileSearch = CompanyMobileSearch;
export const AssetMobileSecondaryButton = CompanyMobileSecondaryButton;
export const AssetMobileSection = CompanyMobileSection;
export const AssetMobileSectionHeader = CompanyMobileSectionHeader;
export const AssetMobileSwitchField = CompanyMobileSwitchField;
export const AssetMobileSwitchGrid = CompanyMobileSwitchGrid;
export const AssetMobileUploadPanel = CompanyMobileUploadPanel;
export const MobileAssetHeader = MobileCompanyHeader;

export const AssetMobileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const AssetMobileCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  background: #ffffff;
`;

export const AssetMobileCardMain = styled.div`
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr) 20px;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
`;

export const AssetMobileThumb = styled.div`
  width: 68px;
  height: 66px;
  overflow: hidden;
  border-radius: 4px;
  background: #f4f6f9;

  .ant-image,
  .ant-image-img {
    width: 68px !important;
    height: 66px !important;
    object-fit: cover;
  }
`;

export const AssetMobileCardBody = styled.div`
  min-width: 0;
`;

export const AssetMobileCardTitle = styled.div`
  max-width: 100%;
  margin-bottom: 2px;
  overflow: hidden;
  color: #1e1e1e;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AssetMobileCardSubtitle = styled.div`
  max-width: 100%;
  margin-bottom: 6px;
  overflow: hidden;
  color: #768499;
  font-size: 10px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AssetMobileInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, max-content));
  gap: 12px;
  align-items: flex-start;
`;

export const AssetMobileInfoItem = styled.div`
  min-width: 0;
`;

export const AssetMobileInfoLabel = styled.div`
  color: #768499;
  font-size: 10px;
  line-height: 20px;
  white-space: nowrap;
`;

export const AssetMobileInfoValue = styled.div`
  display: flex;
  align-items: center;
  min-height: 16px;
  color: #1e1e1e;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;

  .ant-tag {
    margin-inline-end: 0;
    padding: 1px 8px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    text-transform: capitalize;
  }
`;

export const AssetMobileMoreButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1e1e1e;
  cursor: pointer;
`;

export const AssetMobileDetailButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 32px;
  padding: 6px 20px;
  border: 0;
  border-radius: 18px;
  background: #eaebf0;
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
`;

export const AssetMobileEmptyState = styled.div`
  width: 100%;
  padding: 24px 12px;
  border: 1px solid #e8ecf3;
  border-radius: 12px;
  color: #768499;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
`;
